import { proxy } from 'valtio';

import { type PanelState, type PanelKeys, type PanelKeyToPropsMapping } from './types';

/**
 * The contract responsible for managing the current panel state in databases.
 * Like others similar to it, we will have this contract, but multiple implementations
 * depending on the app mode.
 */
export abstract class PanelManager {
  constructor(
    /**
     * A proxy object containing the current state of the panels.
     *
     * @readonly
     */
    public readonly state: PanelState = proxy({ panel: null, data: undefined })
  ) {}

  abstract showPanel<key extends PanelKeys>(
    panelKey: key,
    data?: PanelKeyToPropsMapping[key]
  ): void;

  abstract hidePanel(): void;

  public getData<T extends PanelKeys>(_key: T) {
    return this.state.data as PanelKeyToPropsMapping[T];
  }
}
